import { gql } from "@apollo/client";

export const PLAYER_SEARCH = gql`
  query PlayerSearch($gameIdentifier: String!, $game: EGames!) {
    playerSearch(gameIdentifier: $gameIdentifier, game: $game) {
      creator
      history
      platform
      success
      puuid
      errors {
        code
        field
        message
      }
    }
  }
`;
